<template>
    <div class="overview-tabs">
        <ul class="overview-tabs__list">
            <li
                class="overview-tabs__item"
                v-for="(tab, index) in tabs"
                :key="index"
                :class="[{'-active': activeTab === tab.value}, tab.value]"
                @click="switchTab(tab.value)"
                v-if="showTab(tab.value)"
            >
                {{ tab.label }}
            </li>
        </ul>
        <div class="overview-tabs__content">
            <slot :name="activeTab"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            hasMaterials: Boolean,
            hasMoreThanOneMaterial: Boolean,
            isLoggedIn: Boolean,
            hasValidInstructor: Boolean
        },
        computed: {
            tabs () {
                return [
                    { value: 'tab-1', label: this.$t('CourseOverviewTabs.course_material') },
                    { value: 'tab-2', label: this.$t('CourseOverviewTabs.other_materials') },
                    { value: 'tab-3', label: this.$t('CourseOverviewTabs.instructor') }
                ]
            }
        },
        data () {
            return {
                activeTab: this.hasMaterials && this.isLoggedIn ? 'tab-1' : 'tab-3'
            }
        },
        methods: {
            switchTab (tab) {
                this.activeTab = tab
            },
            showTab (tabName) {
                if (tabName === 'tab-1') {
                    return this.hasMaterials && this.isLoggedIn
                }
                if (tabName === 'tab-2') {
                    return this.hasMoreThanOneMaterial && this.isLoggedIn
                } if (tabName === 'tab-3') {
                    return this.hasValidInstructor
                } else {
                    return true
                }
            }
        },
        watch: {
            hasMaterials: function (newValue) {
                this.activeTab = newValue && this.isLoggedIn ? 'tab-1' : 'tab-3'
            }
        }
    }
</script>

<style lang="scss" scoped>
.overview-tabs {
    margin: 30px 0;
    border: 1px solid $quill_gray;
    background: $white;

    &__list {
        display: flex;
        border-bottom: 1px solid $quill_gray;
    }

    &__content {
        padding: 30px;
        display: flex;
        flex-direction: column;

        [class="mobile_md"] &,
        [class*="desktop"] & {
            flex-direction: row;
        }
    }

    &__item {
        font-size: 1.6rem;
        font-weight: 400;
        list-style: none;
        cursor: pointer;
        margin: -1px 1px -1px -1px;
        padding: 10px 20px;
        font-family: Nunito-Regular, sans-serif;
        background: $heavy_metal;
        color: $white;

        [class="mobile_sm"] & {
            padding: 10px 5px;
        }

        &:not(:last-of-type) {
            border-right: 1px solid $white;
        }

        &.-active {
            background: $orange;
            color: $white;
        }
    }
}
</style>
